export default __webpack_public_path__ + "static/Image045-2_small-d44a404a2325468147ec3fdfbc5a1b33.png";